export default function install(Vue, options) {
  var vm = new Vue({
    data: {
      user: {}
    }
  });

  Object.defineProperties(Vue.prototype, {
    $user: {
      get: function() {
        return vm.user;
      },
      set: function(value) {
        vm.user = value;
        return this;
      }
    }
  });

  axios
    .get("/api/account/ManageInfo?returnUrl=%2F&generateState=true")
    .then(response => {
      vm.user = response.data;
    });
}



//////////////////
// WEBPACK FOOTER
// ./Helpers/Plugins/compte.js
// module id = null
// module chunks = 